import { Text } from "@gravity-ui/uikit";
import { useAtom } from "@reatom/npm-react";
import { motion } from "framer-motion";

import { MODAL_SLIDES, slideContentAnimation } from "../constants";
import { swiperAtom } from "../store";
import css from "../WelcomeModal.module.scss";

export const SliderContent = () => {
  const [swiperRef] = useAtom(swiperAtom);

  const slide = MODAL_SLIDES[swiperRef?.activeIndex || 0];

  return (
    <motion.div
      className={css.slideContainer}
      {...slideContentAnimation}
      key={`slide-content.${swiperRef?.activeIndex || 0}`}
    >
      <Text variant="subheader-3">{slide.title}</Text>
      <Text variant="caption-2" color="secondary">
        {slide.text}
      </Text>
    </motion.div>
  );
};
